import { IconButton } from '@chakra-ui/react';
import { queryClient } from '@app/context/AppContextWrapper';
import { QueryKeys } from '@app/constants/queryKeys';
import { Icon } from '@app/components/Icon';
import React, { FC } from 'react';
import { useCartStore } from '@app/state/nftCartStore';

type Props = {
  id: string;
};

export const RemoveItemButton: FC<Props> = ({ id }) => {
  const { remove } = useCartStore();

  return (
    <IconButton
      padding="8px"
      borderRadius="8px"
      onClick={async () => {
        remove(id);
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.GET_NFT_MARKETPLACE_LISTING_FOR_CART]
        });
      }}
      icon={<Icon name="trashBin" />}
      aria-label="delete"
    />
  );
};
